import { Skeleton as AntdSkeleton } from 'antd';
import React from 'react';

const Skeleton = ({ active = true, ...props }) => {
    return <AntdSkeleton active={active} {...props} />;
};

Skeleton.Button = AntdSkeleton.Button;
Skeleton.Avatar = AntdSkeleton.Avatar;
Skeleton.Input = AntdSkeleton.Input;
Skeleton.Image = AntdSkeleton.Image;
Skeleton.Node = AntdSkeleton.Node;

export default Skeleton;
